module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    免费云服务器延期\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "col-label",
    staticStyle: {
      "margin": "0 0 0 0.2rem"
    }
  }, [_vm._v("\n          发帖地址：\n        ")])]), _vm._v(" "), _c('flexbox-item', [_c('group', {
    staticStyle: {
      "margin-left": "-1rem"
    }
  }, [_c('x-input', {
    model: {
      value: (_vm.url),
      callback: function($$v) {
        _vm.url = $$v
      },
      expression: "url"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "col-label"
  }, [_vm._v("\n            发帖截图：\n          ")])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "col-img"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showimg),
      expression: "!showimg"
    }],
    attrs: {
      "src": require("../../assets/img/img3.png"),
      "alt": "请上传现场图片",
      "width": "135",
      "height": "102"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimg),
      expression: "showimg"
    }],
    attrs: {
      "src": _vm.dataUrl,
      "width": "135",
      "height": "102"
    }
  })]), _vm._v(" "), _c('x-button', {
    staticClass: "col-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("提交")])], 1), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "col-txt"
  }, [_c('p', [_vm._v("JPG或PNG格式")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("请上传发帖截图")]), _vm._v(" "), _c('label', {
    staticClass: "choose-file",
    attrs: {
      "for": "fileImg1"
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('input', {
    ref: "inputer",
    staticClass: "z-width-30-precent",
    staticStyle: {
      "visibility": "hidden",
      "width": "0.1rem"
    },
    attrs: {
      "type": "file",
      "id": "fileImg1",
      "name": "CertImg"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn-master"
  }, [_c('p', [_vm._v("注：具体延期说明请用电脑查看PC端的具体说明")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c1cea62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/freevpsdelay.vue
// module id = HI9G
// module chunks = 1